var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('span',{staticClass:"text-primary cursor-pointer",on:{"click":_vm.openPopup}},[_vm._v(_vm._s(_vm.params.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }